import { render, staticRenderFns } from "./right-second.vue?vue&type=template&id=85cc3e2e&scoped=true&"
import script from "./right-second.vue?vue&type=script&lang=js&"
export * from "./right-second.vue?vue&type=script&lang=js&"
import style0 from "./right-second.vue?vue&type=style&index=0&id=85cc3e2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cc3e2e",
  null
  
)

export default component.exports